<template>
  <div class="infinite-pagination pagination-progress-bar">
    <div>
      <button-fi
        v-if="paginationPage < paginationTotal && showMoreButton"
        :href="href"
        :class="{
          'pagination-progress-bar__button': true,
          'button-fi__tertiary': true,
        }"
        :disabled="disabledState"
        @click="loadMore"
      >
        {{
          showMoreButtonText ? showMoreButtonText : dict.get('product-List.Pagination.Load-More')
        }}
      </button-fi>

      <div class="pagination-progress-bar__text">
        <slot> {{ paginationPage }} / {{ paginationTotal }} </slot>
      </div>
    </div>

    <div class="pagination-progress-bar__bar">
      <div
        class="pagination-progress-bar__bar-progress"
        :style="{ width: `${Math.min(progressbarValue, 100)}%` }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ButtonFi from '@/components/atoms/button-fi/ButtonFi.vue';
import { useDict, useFischer } from '@/composables/fischerPlugin';

interface Props {
  queryParams?: string | null;
  paginationPage: number;
  paginationTotal: number;
  progressbarValue: number;
  disabledState?: boolean;
  showMoreButton?: boolean;
  showMoreButtonText?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  queryParams: null,
  disabledState: false,
  showMoreButton: true,
  showMoreButtonText: null,
});

const emit = defineEmits<{
  loadmore: [];
}>();

const dict = useDict();
const fischer = useFischer();

const getPaginationButtonLink = computed(() => {
  return props.paginationPage + 1;
});

const href = computed(() => {
  if (props.disabledState) {
    return undefined;
  }
  return `${props.queryParams ? props.queryParams + '&' : '?'}page=${
    getPaginationButtonLink.value
  }`;
});

const loadMore = (evt: Event) => {
  if (fischer.query('page')) {
    if (href.value) {
      window.location.href = href.value;
      evt.preventDefault();
    }
    return;
  }
  evt.preventDefault();
  emit('loadmore');
};
</script>

<style scoped src="./pagination-progress-bar" />
